import React from 'react';
import {Plugins, Atom} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {createRgbaColor} from '@packages/systems/core/utils/ColorUtils';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {
  DATA_ATTR_NODE_TYPE,
  NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_FORM,
} from '@packages/systems/commerce/constants';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const Discounts = Atom.createRender(
  ({attributes, classes, data, generateAttributes, renderChild}) => {
    return (
      <form
        {...generateAttributes(
          attributes.set(
            DATA_ATTR_NODE_TYPE,
            NODE_TYPE_COMMERCE_CHECKOUT_DISCOUNT_FORM
          ),
          classes
        )}
      >
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child)
        )}
      </form>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Discounts',
  render: Discounts,
  fields: {children: TListOfElement},
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Commerce'), iconName('Discounts12')),
  },
  showEmpty: true,
  constraints: {
    ancestors: [
      // TODO:
      // This is the same as CommerceUtils#CommerceCheckoutFormConstraint but
      // has a slightly different "name" for the error message. Check this.
      {
        is: [
          'CommerceCheckoutFormContainer',
          'CommercePaypalCheckoutFormContainer',
        ],
        name: 'Checkout Form or Checkout (Paypal) Form',
        rule: 'ExactlyOne',
      },
      {
        is: 'CommerceCheckoutShippingMethodsList',
        rule: 'Forbid',
      },
      {
        is: 'CommerceCheckoutBillingAddressToggleWrapper',
        rule: 'Forbid',
      },
      {
        is: 'CommerceCheckoutOrderItemsList',
        rule: 'Forbid',
      },
      {
        is: 'CommerceCheckoutOrderSummaryExtraItemsList',
        rule: 'Forbid',
      },
      {
        is: 'CommerceCheckoutErrorState',
        rule: 'Forbid',
      },
      {
        is: 'CommercePaypalCheckoutErrorState',
        rule: 'Forbid',
      },
      {
        is: 'CommerceCartApplePayButton',
        rule: 'Forbid',
      },
      {
        is: 'CommerceCartQuickCheckoutButton',
        rule: 'Forbid',
      },
    ],
    descendants: [
      {is: 'CommerceCheckoutDiscountsButton', rule: 'ExactlyOne'},
      {is: 'CommerceCheckoutDiscountsInput', rule: 'ExactlyOne'},
    ],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          backgroundColor: createRgbaColor('ffffff'),
          borderBottomColor: createRgbaColor('e6e6e6'),
          borderBottomStyle: 'solid',
          borderBottomWidth: px(1),
          borderLeftColor: createRgbaColor('e6e6e6'),
          borderLeftStyle: 'solid',
          borderLeftWidth: px(1),
          borderRightColor: createRgbaColor('e6e6e6'),
          borderRightStyle: 'solid',
          borderRightWidth: px(1),
          borderTopColor: createRgbaColor('e6e6e6'),
          borderTopStyle: 'solid',
          borderTopWidth: px(1),
          display: 'flex',
          flexWrap: 'wrap',
          paddingBottom: px(20),
          paddingLeft: px(20),
          paddingRight: px(20),
          paddingTop: px(20),
        },
      },
    },
  },
});

export default config;
